import wumaoProjectApi from '@/api/purchaseSalesCenter/wumaoProject.js';
import { filterEmpty } from '@/common/js/util';
export default {
  methods: {
    // 新增
    add() {
      const path = {
        path: '/projectInitiation/wuMaoProjectCreate',
        name: 'wuMaoProjectCreate',
        meta: {
          keepAlive: true,
          title: '创建项目立项',
        },
        query: {
          status: 'create',
        },
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
    // 提交审批
    async submit() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          showClose: true,
          message: '请选择已保存或已驳回的项目进行提交',
          type: 'error',
        });
        return;
      }
      //只有已保存和已驳回的才可以提交
      if (
        !this.multipleSelection.every((item) =>
          ['PIS01', 'PIS03'].includes(item.projectInitiationStatus)
        )
      ) {
        this.$message({
          showClose: true,
          message: '请选择已保存或已驳回的项目',
          type: 'error',
        });
        return;
      }
      const ids = this.multipleSelection.map((item) => item.id);
      this.loading.startLoading();
      const { data } = this.$axios.post(wumaoProjectApi.SUBMIT_APPROVER, {
        ids,
        oaId: this.userInfo.userInfo.oaId,
      });
      this.loading.endLoading();
      if (data.code == 0) {
        this.$message({
          type: 'success',
          message: this.$t('message.success'),
        });
        this.resetBtnClick();
      } else {
        this.$message.error(data.msg);
      }
    },
    // 导出
    export() {
      const ids = this.multipleSelection.map((item) => item.id);
      if (ids.length < 1) {
        this.$message({
          showClose: true,
          message: '请选择导出的数据',
          type: 'error',
        });
        return;
      }
      console.log(this, '111');
      const params = filterEmpty(this.query);
      this.loading.startLoading();
      // 获取数据
      this.$axios.post(wumaoProjectApi.EXPORT_EXCEL, { ...params, ids }).then((res) => {
        this.loading.endLoading();
        if (res.data.code === 0) {
          window.open(res.data.data, '_blank');
        } else {
          this.$alert(res.data.msg);
        }
      });
    },
    // 关闭立项
    close() {
      if (this.multipleSelection.length != 1) {
        this.$message({
          showClose: true,
          message: '请选择一条数据',
          type: 'error',
        });
        return;
      }
      const projectInitiationStatusList = this.multipleSelection.map(
        (item) => item.projectInitiationStatus
      );
      if (!projectInitiationStatusList.every((item) => ['PIS04', 'PIS05'].includes(item))) {
        this.$message({
          showClose: true,
          message: '请选择已生效或执行中的项目',
          type: 'error',
        });
        return;
      }
      if (this.load) return;
      this.loading.startLoading();
      let id = this.multipleSelection[0].id;
      this.$axios
        .post(wumaoProjectApi.CLOSE_BY_ID, {
          id: Number(id),
        })
        .then((res) => {
          this.loading.endLoading();
          if (0 == res.data.code) {
            this.$message({
              type: 'success',
              message: this.$t('message.success'),
            });
            this.searchBtnClick();
          } else {
            this.$alert(res.data.msg);
          }
        });
    },
    // 撤回
    async withdrawHandler() {
      if (this.multipleSelection.length < 1) {
        this.$message({
          showClose: true,
          message: '请选择一条数据',
          type: 'error',
        });
        return;
      }
      const allProjectInitiationStatus = this.multipleSelection.map(
        (item) => item.projectInitiationStatus
      );
      if (!allProjectInitiationStatus.every((item) => ['PIS04', 'PIS05'].includes(item))) {
        this.$message({
          showClose: true,
          message: '请选择已生效或执行中的项目',
          type: 'error',
        });
        return;
      }
      const ids = this.multipleSelection.map((item) => +item.id);
      const { data } = await this.$axios.post(wumaoProjectApi.WITHDRAW, ids);
      if (data.code == 0) {
        this.$message.success('撤销成功');
        // 刷新列表
        this.getTableData();
      } else {
        this.$message.error(data.msg);
      }
    },
    withdrawApprovalHandler() {
      // 撤回审批
      if (this.multipleSelection.length == 0) {
        this.$message({
          showClose: true,
          message: '请选择提交',
          type: 'error',
        });
        return;
      }
      if (this.multipleSelection.some((item) => item.projectInitiationStatus != 'PIS02')) {
        this.$message.error('只有审批中才可以撤回审批');
        return;
      }
      const idList = this.multipleSelection.map((item) => item.id);
      console.log(idList);
      this.loading.startLoading();
      this.$axios
        .post('/sales/goodsTradeProject/withdrawOA', idList)
        .then((res) => {
          this.loading.endLoading();
          const { code, msg } = res.data;
          if (code == 0) {
            this.$message.success('撤回成功');
            this.resetBtnClick();
          } else {
            this.$message.error(msg);
          }
        })
        .catch(() => {
          this.loading.endLoading();
        });
    },
    // 招标完成冻结
    finish() {
      if (this.multipleSelection.length != 1) {
        this.$message({
          showClose: true,
          message: '请选择一条数据',
          type: 'error',
        });
        return;
      }
      const projectInitiationStatusList = this.multipleSelection.map(
        (item) => item.projectInitiationStatus
      );
      if (!projectInitiationStatusList.every((item) => ['PIS04', 'PIS05'].includes(item))) {
        this.$message({
          showClose: true,
          message: '请选择已生效或执行选择已生效或执行中且招标状态为空的项目行中的项目',
          type: 'error',
        });
        return;
      }
      this.projectFinishId = this.multipleSelection[0].id;
      this.isExecuted = this.multipleSelection[0].projectInitiationStatus === 'PIS05'; //已生效
      this.dialogVisible = true;
    },
    backendApproval() {
      // 后台审批
      if (this.multipleSelection.length == 0) {
        this.$message({
          showClose: true,
          message: '请选择提交',
          type: 'error',
        });
        return;
      }
      const idList = this.multipleSelection.map((item) => item.id);
      console.log(idList);
      this.loading.startLoading();
      this.$axios
        .post('/sales/goodsTradeProject/backendApproval', idList)
        .then((res) => {
          this.loading.endLoading();
          const { code, msg } = res.data;
          if (code == 0) {
            this.$message.success('后台审批成功');
            this.resetBtnClick();
          } else {
            this.$message.error(msg);
          }
        })
        .catch(() => {
          this.loading.endLoading();
        });
    },
  },
};
